import { DateRangePicker, DateRangePickerProps } from '@adamftd/x-date-pickers-pro';
import { Calendar } from 'react-feather';
import IconFeather from 'src/components/common/Icon';

const DateRangePickerWithDefaultIcon = (props: DateRangePickerProps<ExpectedAny>) => {
  return (
    <DateRangePicker
      {...props}
      slotProps={{
        actionBar(ownerState) {
          return {
            actions: ['clear'],
          };
        },
        textField: {
          InputProps: {
            endAdornment: <IconFeather muiProps={{ fontSize: 'small', color: 'action' }} icon={<Calendar />} />,
          },
          ...props.slotProps?.textField,
        },
      }}
    />
  );
};

export default DateRangePickerWithDefaultIcon;
